var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.914,
    height: 18,
    viewBox: "0 0 17.914 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M15.554,2.616A8.922,8.922,0,0,0,1.515,13.378L.25,18l4.728-1.24a8.91,8.91,0,0,0,4.262,1.086h0A8.923,8.923,0,0,0,15.554,2.616ZM9.244,16.339h0a7.4,7.4,0,0,1-3.773-1.033L5.2,15.145l-2.806.736.749-2.736-.176-.28a7.414,7.414,0,1,1,6.28,3.474Zm4.066-5.552c-.223-.112-1.319-.651-1.523-.725s-.353-.111-.5.112-.576.725-.706.874-.26.167-.483.056A6.087,6.087,0,0,1,8.306,10a6.723,6.723,0,0,1-1.24-1.544c-.13-.223,0-.332.1-.455a6.3,6.3,0,0,0,.557-.762.41.41,0,0,0-.019-.39c-.056-.112-.5-1.208-.687-1.655s-.365-.376-.5-.383S6.235,4.8,6.086,4.8a.819.819,0,0,0-.594.279,2.5,2.5,0,0,0-.78,1.859,4.335,4.335,0,0,0,.91,2.305,9.934,9.934,0,0,0,3.807,3.365,12.757,12.757,0,0,0,1.271.47,3.055,3.055,0,0,0,1.4.088,2.3,2.3,0,0,0,1.5-1.06,1.862,1.862,0,0,0,.13-1.06C13.682,10.954,13.534,10.9,13.311,10.787Zm0,0",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.71b8ad68.svg";
export { ForwardRef as ReactComponent };